import { useState } from 'react'

import * as Social from 'components/SocialShareButtons'
import { useThrottledScroll } from 'services/hooks/'

import { Breadcrumb } from './Breadcrumb/Breadcrumb'

import css from './FixedHeader.module.css'

export type FixedHeaderProps = {
    title: string
    adaptive: Record<string, string>
    postUrl: string
}

export default function FixedHeader({ title, adaptive, postUrl }: FixedHeaderProps) {
    const [isAtTop, setAtTop] = useState(true)
    const [isScrollingUp, setScrollingUp] = useState(true)

    /* Detect scrolling to determine if we need to show or hide the breadcrumbs */
    useThrottledScroll(() => {
        let scrollTop = document.documentElement.scrollTop || 0

        return () => {
            setAtTop(document.documentElement.scrollTop === 0)
            setScrollingUp(document.documentElement.scrollTop < scrollTop)
            scrollTop = document.documentElement.scrollTop
        }
    })

    return (
        <div>
            {/* Static one at the top */}
            <header className={`${css.staticHeader} ${isAtTop ? css.atTop : ''}`}>
                <div className={adaptive.container}>
                    <Breadcrumb title={title} url={postUrl} />
                </div>
            </header>

            {/* Fixed position hides when scrolling down on mobile */}
            <header
                className={`${css.fixedHeader} ${isScrollingUp ? css.scrollingUp : ''} ${
                    isAtTop ? css.atTop : ''
                }`}
            >
                <div>
                    <div className={css.breadcrumbContainer}>
                        <Breadcrumb title={title} url={postUrl} />
                    </div>

                    <div className={css.socialIconsContainer}>
                        <Social.EmailShareButton title={title} url={postUrl} />
                        <Social.LinkedinShareButton url={postUrl} />
                        <Social.FacebookShareButton title={title} url={postUrl} />
                        <Social.TwitterShareButton title={title} url={postUrl} />
                    </div>
                </div>
            </header>
        </div>
    )
}
